/**
 * Typer for det cachede Shopify-katalog.
 * Svar-formen fra edge fn "shopify-products" er BEVARET fra v1
 * (shopify_products_cache.data-formen) — ændr den ikke uden at ændre serveren.
 */

export interface ShopifyVariant {
  /** gid://shopify/ProductVariant/N */
  id: string;
  title: string;
  sku: string;
  /** EAN/stregkode fra Shopify (kamera-scanning i Hurtig bestilling). */
  barcode?: string | null;
  /** Listepris som streng, INKL. moms. */
  price: string;
  compareAtPrice?: string | null;
  available: boolean;
  inventoryQuantity?: number | null;
  weight?: number | null;
  weightUnit?: string | null;
  costPrice?: string | null;
}

export interface ShopifyProduct {
  /** gid://shopify/Product/N */
  id: string;
  title: string;
  handle: string;
  description: string;
  productType: string;
  vendor: string;
  tags: string[];
  images: { src: string; alt?: string | null }[];
  variants: ShopifyVariant[];
}

/** Svar fra edge fn "shopify-products". */
export interface ShopifyProductsResponse {
  products: ShopifyProduct[];
  cached?: boolean;
  cache_empty?: boolean;
  last_sync?: string | null;
  sync_status?: string | null;
}

export interface ShopifyCollection {
  id: string;
  title: string;
  handle: string;
  description?: string | null;
  image?: { src: string; alt?: string | null } | null;
  productIds: string[];
  hasOverride?: boolean;
}

/** Svar fra edge fn "shopify-collections". */
export interface ShopifyCollectionsResponse {
  collections: ShopifyCollection[];
}

/** Multi-ords-søgning: alle ord skal matche på titel/SKU/vendor/tags. */
export function productMatchesSearch(product: ShopifyProduct, search: string): boolean {
  const words = search.toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = [
    product.title,
    product.vendor,
    product.productType,
    ...product.tags,
    ...product.variants.map((v) => v.sku ?? ""),
    ...product.variants.map((v) => v.title ?? ""),
  ]
    .join(" ")
    .toLowerCase();
  return words.every((w) => haystack.includes(w));
}
